let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5WEe6")).then(() => parcelRequire('b4Lez'));